import { render, staticRenderFns } from "./DigitalZoom.vue?vue&type=template&id=319faf68&scoped=true"
import script from "./DigitalZoom.vue?vue&type=script&lang=js"
export * from "./DigitalZoom.vue?vue&type=script&lang=js"
import style0 from "./DigitalZoom.vue?vue&type=style&index=0&id=319faf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319faf68",
  null
  
)

export default component.exports